import { render, staticRenderFns } from "./downloadListComponent.vue?vue&type=template&id=20771c57&"
import script from "./downloadListComponent.vue?vue&type=script&lang=ts&"
export * from "./downloadListComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports